import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "contact-page" }
const _hoisted_2 = { class: "contact-main" }
const _hoisted_3 = { class: "info-box" }
const _hoisted_4 = { class: "box" }
const _hoisted_5 = { class: "phone" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "box" }
const _hoisted_8 = { class: "btn" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "kefu-box" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "kefu-box2" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "wechat-box" }
const _hoisted_15 = { class: "phone-box" }
const _hoisted_16 = ["src"]

import { baseUrl } from '@/utils';

export default /*@__PURE__*/_defineComponent({
  __name: 'Contact',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "top-banner" }, [
      _createElementVNode("div", { class: "banner-info" }, [
        _createElementVNode("div", { class: "label" }, "用心服务，全程守护")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[14] || (_cache[14] = _createElementVNode("div", { class: "sub-title" }, "售前咨询", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "label" }, "购买咨询", -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              src: _unref(baseUrl) + '/icon-phone.png',
              alt: ""
            }, null, 8, _hoisted_6),
            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "number" }, "13911834340", -1)),
            _cache[1] || (_cache[1] = _createElementVNode("span", null, "（微信同号）", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "label" }, "企业版试用", -1)),
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "info" }, "留下你的联系方式和咨询的问题，我们将在24小时内联系您", -1)),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("img", {
              src: _unref(baseUrl) + '/icon-edit.png',
              alt: ""
            }, null, 8, _hoisted_9),
            _cache[3] || (_cache[3] = _createTextVNode(" 填写表单 "))
          ])
        ])
      ]),
      _cache[15] || (_cache[15] = _createElementVNode("div", { class: "sub-title" }, "商务合作", -1)),
      _createElementVNode("div", _hoisted_10, [
        _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"bg\" data-v-1e0d0cfe><div class=\"label\" data-v-1e0d0cfe>诚启未来，信筑共赢</div><div class=\"space\" data-v-1e0d0cfe></div><div class=\"label2\" data-v-1e0d0cfe>商务合作电话</div><div class=\"phone\" data-v-1e0d0cfe> 13911834340 <span class=\"small\" data-v-1e0d0cfe>（微信同号）</span></div></div>", 1)),
        _createElementVNode("img", {
          src: _unref(baseUrl) + '/contract.png',
          class: "kefu-bg",
          alt: ""
        }, null, 8, _hoisted_11)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("img", {
          src: _unref(baseUrl) + '/kefu.png',
          class: "kefu-bg2",
          alt: ""
        }, null, 8, _hoisted_13),
        _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"info\" data-v-1e0d0cfe><div class=\"sub-title2\" data-v-1e0d0cfe>售后服务与投诉</div><div class=\"item-box\" data-v-1e0d0cfe><div class=\"item\" data-v-1e0d0cfe><div class=\"label\" data-v-1e0d0cfe>售后服务</div><div class=\"value\" data-v-1e0d0cfe>13911834340<span class=\"gray\" data-v-1e0d0cfe>（微信同号）</span></div></div><div class=\"item\" data-v-1e0d0cfe><div class=\"label\" data-v-1e0d0cfe>投诉电话</div><div class=\"value\" data-v-1e0d0cfe>18845893490</div></div></div></div>", 1))
      ]),
      _cache[16] || (_cache[16] = _createElementVNode("div", { class: "sub-title" }, "微信小程序", -1)),
      _createElementVNode("div", _hoisted_14, [
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "circle-bg1" }, null, -1)),
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "circle-bg2" }, null, -1)),
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "circle-bg3" }, null, -1)),
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "circle-bg4" }, null, -1)),
        _createElementVNode("div", _hoisted_15, [
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "label" }, "“医信圈”小程序", -1)),
          _createElementVNode("img", {
            src: _unref(baseUrl) + '/qrcode.jpg',
            alt: ""
          }, null, 8, _hoisted_16),
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "btn" }, "扫码免费查看最新行业资讯", -1))
        ])
      ])
    ])
  ]))
}
}

})